export const movieGenres = ["全部", "动作", "科幻", "悬疑", "剧情", "喜剧", "爱情", "犯罪", "冒险", "古装", "奇幻", "惊悚", "青春", "家庭", "武侠"];

export const tvGenres = ["全部", "都市", "悬疑", "古装", "科幻", "剧情", "犯罪", "历史", "爱情", "青春", "家庭", "医疗", "战争", "喜剧", "冒险"];

export const regions = ["全部", "中国大陆", "美国", "英国", "日本", "韩国"];

export const yearRanges = [
  { label: "全部", value: "all" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
  { label: "2021", value: "2021" },
  { label: "2020及以前", value: "older" },
];

export const sortOptions = [
  { label: "按热度", value: "hot" },
  { label: "按更新时间", value: "updated" },
  { label: "按评分", value: "rating" },
];

export const PAGE_SIZE = 20;